//@flow

import React, { Component, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import api from '../../lib/api';
import { camelizeKeys } from 'humps';

import endpoints from '../../lib/endpoints';
import MountainFinder from './MountainFinder';

type Props = { id: string };

type State = { mF: Object | null };

export default class MountainFinderWrapper extends Component<Props, State> {
  state = { mF: null };

  componentDidMount() {
    this.fetchMountainFinder();
  }

  fetchMountainFinder = async () => {
    const response = await api.get(endpoints.themes.mountainFinder(this.props.id));
    //check whether the response contains
    // mountain finder object
    if (response.data) this.setState({ mF: camelizeKeys(response.data[0]) });
  };

  render() {
    const { mF } = this.state;

    return (
      <Fragment>
        {isEmpty(mF) ? null : <MountainFinder mountainFinder={mF} {...this.props} />}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MountainFinder/index.jsx